<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="400px">
            <pricePuListAdminAction v-if="showStatus" ref="pricePuListAdminAction" @drawerCancel="drawerCancel" :actionData="actionData">
            </pricePuListAdminAction>
        </el-drawer>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" :buttonFlag="false" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <vSearch @searchData="searchData" :flagList="[]" @openSearchs="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead>
                </vSearch>
            </div>
        </div>
        <div class="page_content_center">
            <el-table size="mini" v-if="pageShowData" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
                <el-table-column label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.row.index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <template v-for="(tableValye, tableKey) in pageShowData.tableList">
                    <el-table-column v-if="tableValye.isShow == 1" :key="tableKey" show-overflow-tooltip :prop="tableValye.entityField" :label="tableValye.showField">
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'date'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.fieldType == 'datetime'">
                                <span v-if="scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField],true) }}
                                </span>
                            </span>
                            <span v-else-if="tableValye.fieldType == 'formatter'">{{$common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</span>
                            <span v-else>
                                {{ scope.row[tableValye.entityField] }}
                            </span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../byComponents/SearchScheme.vue";
import indexJs from './index';

import pricePuListAdminAction from "@/components/pricePuListAdminAction.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        pricePuListAdminAction
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                page: 1,
                rows: 30,
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: []
            },

            buttonList: [],
            selectedDataIndex: 0,
            pageShowData: indexJs.pricePuListAdmin,
            formDataList: indexJs.pricePuListAdmin.formList,
            seId: "",
            seWidth: "",
            seTitle: "",
            seWidth: "",
            sField: "",
            parentSearchData: {},
            DialogVisible: false,
            seType: '',
            smId: '',
            showStatus: false,
            actionData: {},

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //方法集合
    methods: {
        // 子组件触发
        drawerCancel(commitData) {
            this.showStatus = false;
            commitData && this.getDataList();
        },
        changeInputModel(val) {
            console.log(val);
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true
            this.seId = sId
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },
        getPageInfo() {
            let obj = this.$common.getSearchData(this.pageShowData.jurHead, 'page', "rows", 30)
            for (const key in obj) {
                this.$set(this.getRequestData, key, obj[key])
            }
            this.getDataList();
            this.getButtonList();
        },
        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 1:
                    this.actionData = {
                        cate: 0,
                        formData: this.formDataList,
                        oldData: "",
                        orderId: "",
                        printSouce: "",
                        printJurId: "",
                    };
                    this.showStatus = true;
                    break;
                case 2:
                    let dataInfo = this.returnData.list[this.selectedDataIndex]
                    if (!dataInfo) {
                        return this.$message.error("请先勾选数据")
                    }
                    this.actionData = {
                        cate: 1,
                        formData: this.formDataList,
                        oldData: dataInfo,
                        orderId: "",
                        printSouce: "",
                        printJurId: "",
                    };
                    this.showStatus = true;
                    break;
                case 3:
                    this.delDataAction()
                    break;
                case 15:
                    this.openFormDesign()
                    break;
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },


        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.pupriceListqueryList(this.getRequestData)
            if (responseData.status == 200) {
                this.returnData.list = this.$common.getIndex(responseData.result.list)
                this.returnData.total = responseData.result.total
                this.selectedDataIndex = 0
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

        // 删除数据
        delDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            if (!dataInfo) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var delData = {
                    ids: [dataInfo.id]
                }
                let responseData = await this.$http.pupriceListdelete(delData)
                if (responseData.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });

                    this.getDataList()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            })

        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

/* .el-tabs--border-card_new{
	height: 85vh;
	overflow-y: scroll;
} */
</style>